<script setup>
import { ref, onMounted } from 'vue'
import { useFilingDetailStore } from '../../stores/filingDetailStore'
import { useGlobalStore } from '../../stores/globalStore'
import BModal from '../bootstrap/BModal.vue'

const filingDetailStore = useFilingDetailStore()
const globalStore = useGlobalStore()

const showChangeStatusAlert = ref(false)

async function changeStatusToInProgress() {
  try {
    globalStore.setIsLoading(true)
    await filingDetailStore.changeFilingStatus('progress')
  } catch (error) {
    console.error('Error changing status to in progress:', error)
    alert('Failed to change status to in progress. Please try again.')
  } finally {
    globalStore.setIsLoading(false)
  }
}

function askForStatusChange() {
  showChangeStatusAlert.value = true
}
</script>
<template>
  <div
    v-if="
      filingDetailStore.currentFiling.filingStatus ===
      'submitted_for_processing'
    "
    class="card card-sm mb-3"
  >
    <div class="card-body">
      <div class="d-flex">
        <div class="me-3 text-primary">
          <i class="fa-duotone fa-solid fa-info-circle"></i>
        </div>
        <div>
          This filing has been
          <strong>Submitted for Processing.</strong><br />
          <small>
            <a class="card-link" href="#" @click="askForStatusChange">
              Do you need to make a change?
            </a>
          </small>
        </div>
      </div>
    </div>
  </div>
  <BModal
    id="change-status-alert"
    title="Do you need to make a change?"
    ok-title="Yes, I need to make a change"
    :visible="showChangeStatusAlert"
    @update:visible="showChangeStatusAlert = $event"
    @ok="changeStatusToInProgress"
  >
    <div>
      <p>
        By clicking below you will reopen your filing for edits. You will need
        to resubmit for processing before our team will process the filing for
        you.
      </p>
    </div>
  </BModal>
</template>
